/* eslint-disable max-len */
import { setting } from './../../../setting';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Injectable} from '@angular/core';
import { NotificationService } from 'app/shared/notifications/notification.service';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
@Injectable()

export class HomeService {
  private appUrl = setting.apiBookingUrl;
  private downloadVoucherInit: boolean = false;

	constructor(
                private _http: HttpClient,
                private notificationService: NotificationService,
              ) {
	}

  ratesInfo(infoAgencyConsult: any): Observable<any> {
    const url = `${this.appUrl}moebius-data`
    return this
                ._http
                .get<any>(
                   `${url}?escala=${infoAgencyConsult.channel}&locacion=${infoAgencyConsult.location_agency_id}&tipo=${infoAgencyConsult.type}&idioma=${infoAgencyConsult.language}`,
                  )
  }

 downloadDocument(data: any, infoAgencyConsult): void {


     if(this.downloadVoucherInit) {
      console.warn('Descarga en proceso');
      return;
    }

    this.downloadVoucherInit = true;

  const headers = new HttpHeaders()
    .set('x-api-user', setting.booking_api_user)
    .set('x-api-key', setting.booking_api_key);

  // const url = `${this.urlUsb}downloadVouchers/${id}/${clientId}`;
  const url =`${this.appUrl}moebius-data?escala=${infoAgencyConsult.channel}&locacion=${infoAgencyConsult.location_agency_id}&id=${data.archivo_id}&idioma=${infoAgencyConsult.language}`;
      this.notificationService.loading('Descargando voucher...');

  // ✅ Usar HttpClient con responseType: 'blob'
  this._http.get(url, {
    headers: headers,
    responseType: 'blob'
  }).subscribe({
    next: (blob) => {

        this.downloadVoucherInit = false;
        this.notificationService.closeLast();
        this.notificationService.success('Voucher descargado correctamente');

      const link = document.createElement('a');
      const blobUrl = window.URL.createObjectURL(blob);
      link.href = blobUrl;
      link.download = `Circuitos.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    },
    error: (error) => {
      this.notificationService.closeLast();
      console.error('Error al descargar:', error);
      this.notificationService?.error('Error al descargar el itinerario');
    }
  });
 }

}
